export default "https://wpclipart.com/money/bills/money_bill.png";



// WEBPACK FOOTER //
// ./src/components/icon.js